import { Footer } from '../components/Footer.js';
import { Nav } from '../components/Nav.js';

const SECTIONS = [
  {
    id: 'editeur',
    n: '01',
    title: 'Éditeur du site',
    content: (
      <table>
        <tbody>
          <tr>
            <td>Raison sociale</td>
            <td>Cadran SAS (en cours d'immatriculation)</td>
          </tr>
          <tr>
            <td>Forme juridique</td>
            <td>Société par actions simplifiée</td>
          </tr>
          <tr>
            <td>Siège social</td>
            <td>Lyon, France</td>
          </tr>
          <tr>
            <td>Capital</td>
            <td>À compléter</td>
          </tr>
          <tr>
            <td>SIRET</td>
            <td>À compléter</td>
          </tr>
          <tr>
            <td>Directeur de la publication</td>
            <td>À compléter</td>
          </tr>
        </tbody>
      </table>
    ),
  },
  {
    id: 'hebergement',
    n: '02',
    title: 'Hébergement',
    content: (
      <>
        <p>Le site est hébergé sur un serveur VPS situé en Union européenne.</p>
        <p>
          Le service relay Cadran tourne sous Docker sur un VPS Lumadoc (localisation contractuelle
          à confirmer — voir notre politique de confidentialité).
        </p>
      </>
    ),
  },
  {
    id: 'contact',
    n: '03',
    title: 'Contact',
    content: (
      <table>
        <tbody>
          <tr>
            <td>E-mail</td>
            <td>bonjour@cadran.cloud</td>
          </tr>
          <tr>
            <td>Adresse postale</td>
            <td>Lyon, France (adresse complète à compléter)</td>
          </tr>
        </tbody>
      </table>
    ),
  },
  {
    id: 'propriete',
    n: '04',
    title: 'Propriété intellectuelle',
    content: (
      <p>
        L'ensemble du contenu de ce site (textes, visuels, code source, marques) est la propriété
        exclusive de Cadran SAS ou de ses ayants droit. Toute reproduction, même partielle, est
        soumise à autorisation préalable écrite.
      </p>
    ),
  },
  {
    id: 'responsabilite',
    n: '05',
    title: 'Responsabilité',
    content: (
      <p>
        Cadran s'efforce de maintenir les informations publiées à jour et exactes. L'éditeur ne
        saurait être tenu responsable des dommages directs ou indirects liés à l'utilisation du site
        ou à l'indisponibilité temporaire de celui-ci.
      </p>
    ),
  },
  {
    id: 'litiges',
    n: '06',
    title: 'Litiges',
    content: (
      <p>
        En cas de litige, le droit français est applicable. À défaut d'accord amiable, les tribunaux
        compétents du ressort de Lyon sont seuls compétents.
      </p>
    ),
  },
] as const;

export function MentionsLegales() {
  return (
    <>
      <Nav />
      <main>
        <div className="page-intro container">
          <div className="eyebrow">Légal</div>
          <h1>Mentions légales</h1>
        </div>
        <div
          className="container"
          style={{
            display: 'grid',
            gridTemplateColumns: '220px 1fr',
            gap: '56px',
            paddingBottom: '96px',
            alignItems: 'start',
          }}
        >
          <nav style={{ position: 'sticky', top: '96px' }}>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {SECTIONS.map((s) => (
                <li key={s.id} style={{ marginBottom: '8px' }}>
                  <a
                    href={`#${s.id}`}
                    className="small"
                    style={{
                      display: 'block',
                      padding: '6px 0',
                      color: 'var(--ink-soft)',
                      scrollMarginTop: '96px',
                    }}
                  >
                    {s.n} — {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
          <div>
            {SECTIONS.map((s) => (
              <section
                key={s.id}
                id={s.id}
                style={{ marginBottom: '56px', scrollMarginTop: '100px' }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'baseline',
                    gap: '16px',
                    marginBottom: '18px',
                    borderBottom: '1px solid var(--hairline-soft)',
                    paddingBottom: '14px',
                  }}
                >
                  <span
                    className="serif"
                    style={{
                      fontStyle: 'italic',
                      fontWeight: 300,
                      fontSize: '28px',
                      color: 'var(--terracotta-deep)',
                    }}
                  >
                    {s.n}
                  </span>
                  <h2
                    style={{
                      margin: 0,
                      fontFamily: 'Fraunces Variable, serif',
                      fontWeight: 500,
                      fontSize: '22px',
                    }}
                  >
                    {s.title}
                  </h2>
                </div>
                {s.content}
              </section>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
